<template>
  <drag-modal :visible="visible"
              :loading="loading"
              :title="title"
              width="90%"
              @cancel="() => (visible = false)">
    <div class="details"
         style="width: 99%; height: 88vh; z-index: 1;">
      <div class="details_left">
        <div class="detail_real_time"><span>实时模拟</span></div>
        <a-row class="detail_main_r1">
          <a-col :span="14">
            <div class="towerLeftCavan-center">
              <div class="fenglibiao"></div>
              <div class="towerbox">
                <div class="towerbox_hook"
                     :v-bind:range="data.Record.RRange"
                     :style="{
                    left:
                      data.Record.RRange /
                        (data.Config.MaxRange - data.Config.MinRange) +
                      'px'
                  }">
                  <div class="pulley"></div>
                  <div class="towerLine"
                       :v-bind:height="data.Record.Height"
                       :style="{
                      height:
                        19 -
                        (data.Record.Height / data.Config.ArmHeight) * 20 +
                        'vh'
                    }"></div>
                  <div class="towerHook"></div>
                </div>
              </div>
            </div>
          </a-col>
          <a-col class="clockbox"
                 :span="7">
            <div class="clock-line">
              <div class="biaozhen"
                   :v-bind:angle="data.Record.Angle"
                   :style="{
                  transform: 'rotate(' + data.Record.Angle + 'deg)'
                }"></div>
            </div>
          </a-col>
          <a-col :span="3">
            <div style="height: 20vh; width: 20vh; text-align: center;">
              <img v-if="data.Status == 2"
                   src="../../assets/image/status/online.png"
                   alt="正常工作中" />
              <img v-else-if="data.Status == 3"
                   src="../../assets/image/status/warry.png"
                   alt="设备异常" />
              <img v-else
                   src="../../assets/image/status/offline.png"
                   alt="设备离线" />
              <p v-if="data.Status == 2">正常工作中</p>
              <p v-else-if="data.Status == 3">设备异常</p>
              <p v-else>设备离线</p>
            </div>
          </a-col>
        </a-row>

        <div class="detail_data1">
          <ul>
            <li class="detail_data1_li">
              <div>{{ data.Record.RecordDate }}</div>
            </li>
            <li class="detail_data1_li">
              <div>
                <div>吊重</div>
                <div>{{ parseFloat(data.Record.Weight).toFixed(2) }}吨</div>
              </div>
            </li>
            <li class="detail_data1_li">
              <div>
                <div>幅度</div>
                <div>{{ parseFloat(data.Record.RRange).toFixed(2) }}米</div>
              </div>
            </li>
            <li class="detail_data1_li">
              <div>
                <div>高度</div>
                <div>{{ parseFloat(data.Record.Height).toFixed(2) }}米</div>
              </div>
            </li>
            <li class="detail_data1_li">
              <div>
                <div>回转角度</div>
                <div>{{ parseFloat(data.Record.Angle).toFixed(2) }}度</div>
              </div>
            </li>
            <li class="detail_data1_li">
              <div>
                <div>力矩百分比</div>
                <div>{{ parseFloat(data.Record.Moment).toFixed(2) }}%</div>
              </div>
            </li>
            <li class="detail_data1_li">
              <div>
                <div>风速</div>
                <div>
                  {{ parseFloat(data.Record.WindSpeed).toFixed(2) }}米/秒
                </div>
              </div>
            </li>
            <li class="detail_data1_li">
              <div>
                <div>前倾角</div>
                <div>{{ parseFloat(data.Record.Obliguity).toFixed(2) }}度</div>
              </div>
            </li>
          </ul>
        </div>
      </div>
      <div style="margin-top: 20px;float: left;">
        <div class="details_left1"
             style="float: left;">
          <div class="details_left1_datas_box">
            <div class="details_left1_datas"><span>近期吊重跟踪</span></div>
            <div class="tajilishi">塔机历史</div>
          </div>
          <div style="margin:0 auto;width:auto; height: 28.2vh;display: -ms-flexbox;display: -webkit-box;display: flex;-ms-flex-pack: justify;-webkit-box-pack: justify;justify-content: space-between;">
            <Echart :options="weightRecordOptions"
                    id="weightRecordOptions"
                    style=" width: 1131px; height: 28.2vh; -webkit-tap-highlight-color: transparent; user-select: none;"></Echart>
          </div>
        </div>
        <div class="details_left2"
             style="float: left;">
          <div class="details_left2_tasi detail_real_time">
            <span>塔司状态</span>
          </div>
          <div class="details_left2_div1">
            <img src="data:image/png;base64,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"
                 alt="" />
          </div>
          <div class="detail_left2_tit">
            <div v-if="data.OperaterName"
                 class="detail_left2_name">
              <span>姓名：</span> <span>{{ data.OperaterName }}</span>
            </div>
            <div v-if="!data.OperaterName"
                 class="detail_left2_mount_guard">
              <span>未获取到塔司信息</span>
            </div>
          </div>
        </div>
      </div>
      <div class="details_right">
        <div class="details_right1">
          <div v-if="data.Video && data.Video.length > 0">
            <div class="details_right1_diaogou zhgd"
                 style="line-height: 30px;    background: #103163;">
              <select v-model="videoUrl"
                      @change="videoChange"
                      name="videoUrl"
                      id="videoUrl"
                      style="background: #3156b7;color: white;line-height: 26px;">
                <option v-for="playUrl in data.Video"
                        :key="playUrl.LiveAddress"
                        :value="convertAddress(playUrl.LiveAddress)">{{playUrl.Name}}</option>
              </select>
            </div>
            <div style="width: 100%; height: 220px; position: relative;">
              <video ref="videoPlayer"
                     class="video-js vjs-default-skin"
                     style="width: 100%; height: 100%; object-fit: fill"></video>
            </div>
          </div>

          <div v-else
               style="width: 96%; height: 28vh; margin-left: 2%;">
            未配置吊钩可视化设备
          </div>
        </div>
        <div class="details_right2">
          <div class="details_right2_fenxi">
            <p class="details_right2_fenxi_p1">
              故障分析：<span>[{{ alarmStatus }}]</span>
            </p>
            <p>
              <span>分析时间：</span> <span>{{ data.Record.RecordDate }}</span>
            </p>
          </div>
        </div>
        <div class="details_right3">
          <div class="d-flex pt-2 pl-2">
            <span style="color:#5cd9e8">
              <icon name="chart-line"></icon>
            </span>
            <div class="d-flex">
              <span class="fs-xl text mx-2">近期工作循环</span>
            </div>
          </div>
          <dv-scroll-board :config="cycleWorkConfig"
                           ref="cycleWorkBox"
                           style="height:4.0rem" />
        </div>
      </div>
    </div>
  </drag-modal>
</template>
<script>
import DragModal from "@/components/DragModal";
import Echart from "@/common/echart";
import moment from "moment";
import 'videojs-contrib-hls'
//import VueAliplayerV2 from "@/components/AliplayerV2";
const weightRecordOptions = {
  grid: {
    left: "2%",
    right: "2%",
    bottom: "10%",
    containLabel: true
  },
  tooltip: {
    formatter: "{c}t"
  },
  calculable: true,
  xAxis: {
    type: "category",
    boundaryGap: false,
    data: [],
    interval: 0,
    axisTick: {
      show: false,
      inside: true,
      lineStyle: {
        color: "#10899A"
      }
    },
    axisLine: {
      show: false,
      lineStyle: {
        color: "#06D3CD"
      }
    },
    axisLabel: {
      rotate: 8,
      color: "#06D3CD",
      fontSize: 14,
      fontWeight: 300
    }
  },
  yAxis: {
    type: "value",
    show: false,
    splitLine: {
      show: false
    },
    axisLine: {
      lineStyle: {
        color: "#06D3CD"
      }
    },
    axisTick: {
      lineStyle: {
        color: "#10899A"
      }
    },
    axisLabel: {
      showMaxLabel: false,
      color: "#06D3CD",
      fontFamily: "PingFangSC",
      fontSize: 14,
      fontWeight: 300
    }
  },
  series: [
    {
      data: [],
      type: "line",
      smooth: true,
      symbol: "circle",
      areaStyle: {
        normal: {
          color: {
            x: 0,
            y: 0,
            x2: 0,
            y2: 1,
            colorStops: [
              {
                offset: 0,
                color: "#dc3881" // 0% 处的颜色
              },
              {
                offset: 0.7,
                color: "rgba(220,56,129,0)" // 100% 处的颜色
              }
            ],
            globalCoord: false // 缺省为 false
          }
        }
      }
    }
  ]
};
const cycleTemplat = {
  header: ["开始时间", "结束时间", "吊重/吨"],
  data: [],
  rowNum: 7, //表格行数
  headerHeight: 35,
  headerBGC: "#0f1325", //表头
  oddRowBGC: "#0f1325", //奇数行
  evenRowBGC: "#171c33", //偶数行
  index: false,
  columnWidth: [150, 150],
  align: ["center"],
  hoverPause: true
};
export default {
  data () {
    return {
      loading: true,
      visible: false,
      title: "",
      videoUrl: '',
      player: null,
      options: {
        autoplay: true,
        controls: true,
        muted: false,
        bigPlayButton: true,
        textTrackDisplay: false,
        posterImage: false,
        errorDisplay: false,
        hls: {
          withCredentials: true
        }
      },
      connection: null,
      queryParam: {},
      alarmCount: 0,
      alarmStatus: "正常",
      data: {
        Config: {},
        Record: {}
      },
      weightRecordOptions: weightRecordOptions,
      weightRecordOptionsCdata: { category: [], data: [] },
      cycleWorkConfig: cycleTemplat
    };
  },
  beforeDestroy () {
    if (this.player) {
      this.player.dispose()
    }
  },
  components: {
    DragModal,
    //VueAliplayerV2,
    Echart
  },
  watch: {
    weightRecordOptionsCdata: {
      handler (newData) {
        this.weightRecordOptions.xAxis.data = newData.category;
        this.weightRecordOptions.series[0].data = newData.data;
      },
      immediate: true,
      deep: true
    }
  },
  created: function () {
    this.loading = false;
    this.connection = this.$op.getConnect(this);
    if (this.connection) this.setconnection();
  },
  methods: {
    moment,
    videoChange () {
      if (!this.player) {
        this.player = this.$video(this.$refs.videoPlayer, this.options)
      }
      this.player.src([
        {
          src: this.convertAddress(this.videoUrl),
          type: 'application/x-mpegURL'
        }
      ])
      this.player.play()
      console.log(this.videoUrl)
    },
    openForm (device) {
      this.data = device;
      this.title = device.Name + "(" + device.Code + ")";
      this.queryParam = { ProId: device.ProId, DeviceId: device.Id };
      this.loading = false;
      this.visible = true;
      this.loadweightrecord();
      this.loadcyclerecord();
      this.getconnection();
      this.cancelLoading();
    },
    loadweightrecord () {
      this.loading = true;
      this.$http
        .post("/DeviceManage/DeviceTowerRecord/GetLastWeightRecord", {
          id: this.data.Id
        })
        .then(resJson => {
          this.loading = false;

          this.weightRecordOptionsCdata.category = [];
          this.weightRecordOptionsCdata.data = [];
          if (resJson.Data && resJson.Data.length > 0) {
            for (let index = 0; index < resJson.Data.length; index++) {
              const element = resJson.Data[index];
              this.weightRecordOptionsCdata.category.push(
                element.RecordDateText
              );
              this.weightRecordOptionsCdata.data.push(element.value);
            }
          }
        });
    },
    loadcyclerecord () {
      this.loading = true;
      this.$http
        .post("/DeviceManage/DeviceTowerRecordCycle/GetLastDataList", {
          Search: {
            id: this.data.Id
          },
          PageRows: 10,
          SortField: "WorkStartDate",
          SortType: "desc"
        })
        .then(resJson => {
          this.loading = false;
          let cycleWorkData = cycleTemplat;

          if (resJson.Data && resJson.Data.length > 0) {
            for (let index = 0; index < resJson.Data.length; index++) {
              const element = resJson.Data[index];
              cycleWorkData.data.push([
                moment(element.WorkStartDate).format("yyyy-MM-DD HH:mm"),
                moment(element.WorkEndDate).format("yyyy-MM-DD HH:mm"),
                element.WorkWeight
              ]);
            }
            this.cycleWorkConfig = cycleWorkData;
            this.$refs["cycleWorkBox"].updateRows(cycleWorkData.data);
          }
        });
    },
    loadlastrecord () {
      this.$http
        .post("/DeviceManage/DeviceTower/GetLastRecord", { id: this.data.Id })
        .then(x => {
          this.loading = false;
          this.data.Record = x;
          this.weightRecordOptionsCdata.category.push(
            moment(x.RecordDate).format("HH:mm")
          );
          this.weightRecordOptionsCdata.data.push(x.Weight);
          if (x.NoAlarm == 0 || x.NoError == 0) {
            if (x.WindSpeedAlarm == 1) {
              this.alarmStatus = "风速报警";
            }
            if (x.MomentAlarm == 1) {
              this.alarmStatus = "力矩报警";
            }
            if (x.HeightAlarm == 1) {
              this.alarmStatus = "高度报警";
            }
            if (x.MinRangeAlarm == 1) {
              this.alarmStatus = "幅度内限位报警";
            }
            if (x.MaxRangeAlarm == 1) {
              this.alarmStatus = "幅度外限位报警";
            }
            if (x.ObliguityAlarm == 1) {
              this.alarmStatus = "倾角报警";
            }
            if (x.WindSpeedError == 1) {
              this.alarmStatus = "风速传感器故障";
            }
            if (x.RangeError == 1) {
              this.alarmStatus = "幅度传感器故障";
            }
            if (x.HeightError == 1) {
              this.alarmStatus = "高度传感器故障";
            }
            if (x.WeightError == 1) {
              this.alarmStatus = "重量传感器故障";
            }
            if (x.AngleError == 1) {
              this.alarmStatus = "角度传感器故障";
            }
            if (x.ObliguityError == 1) {
              this.alarmStatus = "倾角传感器故障";
            }
          }
        });
    },
    cancelLoading () {
      setTimeout(() => {
        this.getconnection();
        if (!this.connection || typeof this.connection == "undefined") {
          this.loadweightrecord();
          this.loadcyclerecord();
        } else {
          this.setconnection();
        }
      }, 60 * 1000);
    },
    convertAddress (address) {
      var a = address.replace(/^https?:\/\//i, "//")
      console.log(a)
      return a
    },
    getconnection () {
      if (!this.connection) this.connection = this.$op.getConnect(this);
    },
    setconnection () {
      this.connection.on("towerrealtime", x => {
        console.log(x);
        this.data.Record = {
          RecordDate: x.data.recordDate,
          Height: x.data.height,
          Weight: x.data.weight,
          Moment: x.data.moment,
          RatedWeight: x.data.ratedWeight,
          Angle: x.data.angle,
          WindSpeed: x.data.windSpeed,
          Obliguity: x.data.obliguity,
          RRange: x.data.rRange
        };
        this.weightRecordOptionsCdata.category.push(
          moment(x.data.recordDate).format("HH:mm")
        );
        this.weightRecordOptionsCdata.data.push(x.data.weight);
        //报警
        if (x.data.noAlarm == 0 || x.data.noError == 0) {
          if (x.data.windSpeedAlarm == 1) {
            this.alarmStatus = "风速报警";
          }
          if (x.data.momentAlarm == 1) {
            this.alarmStatus = "力矩报警";
          }
          if (x.data.heightAlarm == 1) {
            this.alarmStatus = "高度报警";
          }
          if (x.data.minRangeAlarm == 1) {
            this.alarmStatus = "幅度内限位报警";
          }
          if (x.data.maxRangeAlarm == 1) {
            this.alarmStatus = "幅度外限位报警";
          }
          if (x.data.obliguityAlarm == 1) {
            this.alarmStatus = "倾角报警";
          }
          if (x.data.windSpeedError == 1) {
            this.alarmStatus = "风速传感器故障";
          }
          if (x.data.rangeError == 1) {
            this.alarmStatus = "幅度传感器故障";
          }
          if (x.data.heightError == 1) {
            this.alarmStatus = "高度传感器故障";
          }
          if (x.data.weightError == 1) {
            this.alarmStatus = "重量传感器故障";
          }
          if (x.data.angleError == 1) {
            this.alarmStatus = "角度传感器故障";
          }
          if (x.data.obliguityError == 1) {
            this.alarmStatus = "倾角传感器故障";
          }
        }
      });
      this.connection.on("towercycle", x => {
        this.cycleWorkConfig.data.push([
          moment(x.data.workStartDate).format("yyyy-MM-DD HH:mm"),
          moment(x.data.workEndDate).format("yyyy-MM-DD HH:mm"),
          x.data.workWeight
        ]);
        this.$refs["cycleWorkBox"].updateRows(this.cycleWorkConfig.data, 1);
      });
    }
  }
};
</script>
<style lang="scss">
.details {
  .detail_real_time {
    position: relative;
    margin: 10px;
  }
  .details_left {
    width: 75%;
    height: 48vh;
    border: 1px solid #85a2e2;
    margin-left: 1%;
    float: left;
    .detail_real_time {
      position: relative;
      margin: 10px;
    }
    .towerLeftCavan-center {
      width: 30vh;
      height: 30vh;
      margin: 0 auto 2vh;
      background: url(../../assets/image/tower/td.png) no-repeat 0 1.5vh;
      overflow: hidden;
      position: relative;
      background-size: 100% 100%;
      .fenglibiao,
      .fenglibiao2 {
        width: 4vh;
        height: 2vh;
        background: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACQAAAAOCAYAAABHN77IAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAyJpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDUuMy1jMDExIDY2LjE0NTY2MSwgMjAxMi8wMi8wNi0xNDo1NjoyNyAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvIiB4bWxuczp4bXBNTT0iaHR0cDovL25zLmFkb2JlLmNvbS94YXAvMS4wL21tLyIgeG1sbnM6c3RSZWY9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9zVHlwZS9SZXNvdXJjZVJlZiMiIHhtcDpDcmVhdG9yVG9vbD0iQWRvYmUgUGhvdG9zaG9wIENTNiAoV2luZG93cykiIHhtcE1NOkluc3RhbmNlSUQ9InhtcC5paWQ6RUE1NkJCRTNCQjc0MTFFQTk5RkNGMkJEREZGNDM5Q0EiIHhtcE1NOkRvY3VtZW50SUQ9InhtcC5kaWQ6RUE1NkJCRTRCQjc0MTFFQTk5RkNGMkJEREZGNDM5Q0EiPiA8eG1wTU06RGVyaXZlZEZyb20gc3RSZWY6aW5zdGFuY2VJRD0ieG1wLmlpZDpFQTU2QkJFMUJCNzQxMUVBOTlGQ0YyQkRERkY0MzlDQSIgc3RSZWY6ZG9jdW1lbnRJRD0ieG1wLmRpZDpFQTU2QkJFMkJCNzQxMUVBOTlGQ0YyQkRERkY0MzlDQSIvPiA8L3JkZjpEZXNjcmlwdGlvbj4gPC9yZGY6UkRGPiA8L3g6eG1wbWV0YT4gPD94cGFja2V0IGVuZD0iciI/PmKsIU0AAAGISURBVHja3NRPKARRHMDxfZpduyTFpqQUucnRlpOjg5SchHLBlZOrlHJ2cODAQY4uzg44LRKJEuXPtmUjUrLCmvF9/A5jmhmzfw7y6tPszL4/v/m93zxl7YyGStzKkEAvlnDm2zux+OPWkGs1GvGAG5hFBDSJWfndgGGf+WKh3bEo13dkCc7Ub9ODRxwhjRVEAi5ejkpUiGZbMLq1ynO31v8VxHcSnrBAcGGdoXVHxwFcYQoWlMtk+nkLtlHnE3AN6nFhm8eULV119B3BvqKGLI/JtpBB1OW/Zwk8SDvACark/haDHpk7NDwmucYcPjwyZM+mX7vEtEt2a9Hn0v9eZ0ins8nxRweSvywWxpCM7ZQM6HrYxJ0U6gZSHrWXctnuNp2hdkygC+eYDxBMSBZcls98TQLS42cCjH2Vgh9HN05lR46VnENKakUvksvzM1dSF3HsScHmMzaGNz75nP0c0vv6UuC5o6TI4wXMYRFI1nmq/qn2bwOKOK4FN6NEAaXl5TLFTvQpwACYCFsF5Hh59QAAAABJRU5ErkJggg==);
        position: absolute;
        background-size: 100% 100%;
        top: -0.3vh;
        left: 16%;
        animation: fenglibiaos 3s linear infinite;
      }
      @-webkit-keyframes fenglibiaos {
        0% {
          transform: rotateY(0deg);
        }
        to {
          transform: rotateY(1turn);
        }
      }
      @keyframes fenglibiaos {
        0% {
          transform: rotateY(0deg);
        }
        to {
          transform: rotateY(1turn);
        }
      }

      .towerbox {
        margin-left: 13vh;
        margin-right: 7vh;
        margin-top: 6vh;
        position: relative;
        .towerbox_hook {
          position: absolute;
          top: -4px;
          left: 0;
          width: 3vh;
          transition: left 2s;
          .pulley {
            background: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAwAAAAUCAYAAAC58NwRAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAyJpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDUuMy1jMDExIDY2LjE0NTY2MSwgMjAxMi8wMi8wNi0xNDo1NjoyNyAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvIiB4bWxuczp4bXBNTT0iaHR0cDovL25zLmFkb2JlLmNvbS94YXAvMS4wL21tLyIgeG1sbnM6c3RSZWY9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9zVHlwZS9SZXNvdXJjZVJlZiMiIHhtcDpDcmVhdG9yVG9vbD0iQWRvYmUgUGhvdG9zaG9wIENTNiAoV2luZG93cykiIHhtcE1NOkluc3RhbmNlSUQ9InhtcC5paWQ6MTFBNjQ2QUZERjc1MTFFOUI5OUVBOEJFNzQ1N0Y1OTQiIHhtcE1NOkRvY3VtZW50SUQ9InhtcC5kaWQ6MTFBNjQ2QjBERjc1MTFFOUI5OUVBOEJFNzQ1N0Y1OTQiPiA8eG1wTU06RGVyaXZlZEZyb20gc3RSZWY6aW5zdGFuY2VJRD0ieG1wLmlpZDoxMUE2NDZBRERGNzUxMUU5Qjk5RUE4QkU3NDU3RjU5NCIgc3RSZWY6ZG9jdW1lbnRJRD0ieG1wLmRpZDoxMUE2NDZBRURGNzUxMUU5Qjk5RUE4QkU3NDU3RjU5NCIvPiA8L3JkZjpEZXNjcmlwdGlvbj4gPC9yZGY6UkRGPiA8L3g6eG1wbWV0YT4gPD94cGFja2V0IGVuZD0iciI/PjW7dncAAADMSURBVHjaYnxmZ/qfgQTAxEAiIFkDCxBXMbIycrGKc/jhU/j3y5+Lfz/8vs4I4vzfGgnS+JuA4Y6M3ssPkOUkMPj3/S/Dn1e/sHuUh5mBRZgNVcPPh98Z3m94jlUDhxI3g1CY1B/iQ4kZTH5F1sCKTz0jCxNl8QBxpzI3g3imAoaC/7/+MzByMGFqAEYeAzM/6yBIS+R7+vfTHwwf97zGqohTk4eB20wQLWn8+Mvw+9VPSMj8Q81TrGLsmDawA4NVslSFqn74AiIAAgwA6yoy2JaMhxoAAAAASUVORK5CYII=)
              no-repeat 50%;
            position: absolute;
            left: 0;
            top: 0;
            width: 100%;
            height: 1vh;
          }
          .towerLine {
            width: 40%;
            height: 3vh;
            transition: height 2s;
            background: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAYAAAAwCAYAAAAy7wv4AAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAyJpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDUuMy1jMDExIDY2LjE0NTY2MSwgMjAxMi8wMi8wNi0xNDo1NjoyNyAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvIiB4bWxuczp4bXBNTT0iaHR0cDovL25zLmFkb2JlLmNvbS94YXAvMS4wL21tLyIgeG1sbnM6c3RSZWY9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9zVHlwZS9SZXNvdXJjZVJlZiMiIHhtcDpDcmVhdG9yVG9vbD0iQWRvYmUgUGhvdG9zaG9wIENTNiAoV2luZG93cykiIHhtcE1NOkluc3RhbmNlSUQ9InhtcC5paWQ6MUYxRjNFQkRERjc1MTFFOUI1OTM4NDkxMEQ2MjI4MTYiIHhtcE1NOkRvY3VtZW50SUQ9InhtcC5kaWQ6MUYxRjNFQkVERjc1MTFFOUI1OTM4NDkxMEQ2MjI4MTYiPiA8eG1wTU06RGVyaXZlZEZyb20gc3RSZWY6aW5zdGFuY2VJRD0ieG1wLmlpZDoxRjFGM0VCQkRGNzUxMUU5QjU5Mzg0OTEwRDYyMjgxNiIgc3RSZWY6ZG9jdW1lbnRJRD0ieG1wLmRpZDoxRjFGM0VCQ0RGNzUxMUU5QjU5Mzg0OTEwRDYyMjgxNiIvPiA8L3JkZjpEZXNjcmlwdGlvbj4gPC9yZGY6UkRGPiA8L3g6eG1wbWV0YT4gPD94cGFja2V0IGVuZD0iciI/PjFdGUsAAAAiSURBVHjaYnhmZ/qfAQ2AxJgYcIBRiVGJUYlRiYGRAAgwAKBwBQ86hFJuAAAAAElFTkSuQmCC)
              no-repeat 50%;
            background-size: 100% 100%;
            margin: 0 auto;
          }
          .towerHook {
            width: 100%;
            height: 5vh;
            background: url(data:image/png;base64,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)
              no-repeat 50%;
            background-size: 100% 100%;
          }
        }
      }
    }
    .clockbox > div {
      float: left;
      padding-right: 50px;
    }

    .clock-line {
      height: 25vh;
      width: 25vh;
      border-radius: 50%;
      background: url(data:image/png;base64,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);
      background-size: 100% 100%;
      position: relative;
      .biaozhen {
        height: 100%;
        width: 100%;
        background: url(data:image/png;base64,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);
        background-size: 100% 100%;
        position: absolute;
        left: 0;
        top: 0;
        transform: rotate(45deg);
        transition: all 2s;
      }
    }
    .detail_data1 > ul .detail_data1_li {
      float: left;
      width: 8%;
      display: -ms-flexbox;
      display: flex;
      -ms-flex-align: center;
      align-items: center;
      -ms-flex-pack: center;
      justify-content: center;
      height: 9vh;
      background: #27c656;
      border-radius: 10px;
      text-align: center;
      line-height: 2.5vh;
      font-weight: 700;
      color: #000;
      margin-left: 4%;
    }
  }
  .details_left1 {
    width: 83.7%;
    height: 34vh;
    border: 1px solid #85a2e2;
    margin-left: 1.3%;
    margin-right: 0.1%;
    .details_left1_datas_box {
      margin: 0 auto;
      width: 90%;
      display: -ms-flexbox;
      display: flex;
      -ms-flex-pack: justify;
      justify-content: space-between;
      .details_left1_datas {
        position: relative;
        width: 90%;
        height: 30px;
        margin: 0 auto;
        background: #3156b7;
        line-height: 30px;
        margin-top: 20px;
        padding-left: 10px;
      }
      .tajilishi {
        height: 30px;
        line-height: 30px;
        margin-top: 20px;
        padding: 0 10px;
        background: #0056a9;
        cursor: pointer;
      }
    }
  }
  .details_left2 {
    width: 14.9%;
    height: 34vh;
    border: 1px solid #85a2e2;
    .details_left2_div1 {
      position: relative;
    }
    .details_left2_div1 > img {
      position: absolute;
      height: 140px;
      width: 110px;
      left: 28%;
      top: 10px;
      font-size: 12px;
    }
    .detail_left2_tit {
      position: relative;
      top: 170px;
      line-height: 28px;
      left: 22px;
      font-size: 12px;
    }
  }
  .details_right {
    position: absolute;
    width: 23%;
    right: 10px;

    .details_right1 {
      height: 35vh;
      border: 1px solid #85a2e2;
    }
    .details_right2 {
      height: 10vh;
      border: 1px solid #85a2e2;
      margin-top: 10px;
      .details_right2_fenxi {
        width: 100%;
        line-height: 30px;
        margin-top: 10px;
        margin-left: 4%;
        font-size: 12px;
      }
    }
    .details_right3 {
      position: relative;
      height: 36.7vh;
      border: 1px solid #85a2e2;
      margin-top: 10px;
    }
  }
}
</style>
